import React from 'react';

type BVPageTitleSize = 'page' | 'section';

interface BVPageTitleProps {
  title: string;
  size?: BVPageTitleSize;
}

function BazaarvoiceMark({ size = 'page' }: { size?: BVPageTitleSize }) {
  const classes = size === 'section' ? 'h-7 w-7' : 'h-9 w-9';
  const textSize = size === 'section' ? '11' : '12';

  return (
    <svg
      viewBox="0 0 32 32"
      className={`${classes} flex-shrink-0 text-charcoal dark:text-gray-100`}
      aria-hidden="true"
    >
      <circle cx="16" cy="16" r="13.5" fill="none" stroke="currentColor" strokeWidth="2.5" />
      <text
        x="10.5"
        y="20.75"
        fontSize={textSize}
        fontWeight="700"
        fill="currentColor"
        fontFamily="Inter, system-ui, sans-serif"
      >
        b:
      </text>
    </svg>
  );
}

export function BVPageTitle({ title, size = 'page' }: BVPageTitleProps) {
  const textClasses = size === 'section' ? 'text-[1.15rem]' : '';

  return (
    <span className="flex min-w-0 items-center gap-3">
      <BazaarvoiceMark size={size} />
      <span className={`block truncate ${textClasses}`}>{title}</span>
    </span>
  );
}

export default BVPageTitle;
